export default __webpack_public_path__ + "static/media/nft_image_4.946ff551.png";